import type { SVGProps } from 'react';
const SvgWebsiteClick = (props: SVGProps<SVGSVGElement>) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2383_708)">
      <path
        d="M13.3722 18.4764H3.65735C2.85169 18.4764 2.19596 17.8214 2.19596 17.015V7.7537H20.5428V13.0094C20.5428 13.3857 20.848 13.6909 21.2243 13.6909C21.6006 13.6909 21.9058 13.3857 21.9058 13.0094V4.40765C21.9058 2.85464 20.6428 1.59088 19.089 1.59088H3.64978C2.09677 1.59088 0.833008 2.85388 0.833008 4.40765V17.015C0.833008 18.5725 2.0998 19.8393 3.65735 19.8393H13.3722C13.7485 19.8393 14.0537 19.5342 14.0537 19.1578C14.0537 18.7815 13.7485 18.4764 13.3722 18.4764ZM3.64978 2.95383H19.089C19.8909 2.95383 20.5428 3.60578 20.5428 4.40765V6.39075H2.19596V4.40765C2.19596 3.60654 2.84791 2.95383 3.64978 2.95383Z"
        fill="currentColor"
      />
      <path
        d="M4.53579 5.27617C4.87201 5.27617 5.14457 5.0036 5.14457 4.66738C5.14457 4.33116 4.87201 4.05859 4.53579 4.05859C4.19956 4.05859 3.927 4.33116 3.927 4.66738C3.927 5.0036 4.19956 5.27617 4.53579 5.27617Z"
        fill="currentColor"
      />
      <path
        d="M6.68007 5.27617C7.0163 5.27617 7.28886 5.0036 7.28886 4.66738C7.28886 4.33116 7.0163 4.05859 6.68007 4.05859C6.34385 4.05859 6.07129 4.33116 6.07129 4.66738C6.07129 5.0036 6.34385 5.27617 6.68007 5.27617Z"
        fill="currentColor"
      />
      <path
        d="M8.82436 5.27617C9.16059 5.27617 9.43315 5.0036 9.43315 4.66738C9.43315 4.33116 9.16059 4.05859 8.82436 4.05859C8.48814 4.05859 8.21558 4.33116 8.21558 4.66738C8.21558 5.0036 8.48814 5.27617 8.82436 5.27617Z"
        fill="currentColor"
      />
      <path
        d="M22.4321 15.4332L15.9035 13.447C15.4235 13.3017 14.901 13.4311 14.5451 13.7863C14.1885 14.1429 14.0582 14.6631 14.2051 15.1454L16.1913 21.6747C16.3669 22.2517 16.8705 22.6303 17.4732 22.6387H17.4944C18.088 22.6387 18.5923 22.2767 18.7831 21.7118L19.7115 18.9534L22.4714 18.0235C23.0431 17.8305 23.4066 17.3156 23.3975 16.7136C23.3884 16.1109 23.0091 15.6081 22.4321 15.4332ZM19.2761 17.6631C18.8755 17.7987 18.556 18.1182 18.4212 18.518L17.4951 21.278L15.5105 14.7525L22.0361 16.734L19.2761 17.6631Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2383_708">
        <rect width="24.2303" height="24.2303" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWebsiteClick;
